module.exports = __webpack_public_path__ + "static/img/sjzz61.f3e9d93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sjzz61.png
// module id = 8k3x
// module chunks = 73